import React from 'react';
import { Card, Space, Avatar, Typography, Badge, Button, theme } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useAppointments } from '../data/appointments';

const { Title, Text } = Typography;
const { useToken } = theme;

const AppointmentCard = () => {
  const appointments = useAppointments();
  const { token } = useToken();

  return (
    <>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '24px 24px 16px',
        borderBottom: `1px solid ${token.colorBorderSecondary}`
      }}>
        <Title level={5} style={{ 
          color: token.colorTextHeading, 
          margin: 0,
          fontWeight: 700,
          fontSize: '16px'
        }}>
          Upcoming Appointments
        </Title>
        <Button 
          type="primary" 
          icon={<PlusOutlined />}
          style={{ 
            borderRadius: '12px',
            fontWeight: 500
          }}
        >
          Schedule Appointment
        </Button>
      </div>
      <div style={{ padding: '0 24px 24px' }}>
        {appointments.map(appt => (
          <Card 
            key={appt.id}
            style={{ 
              marginBottom: '16px', 
              borderRadius: '12px',
              border: `1px solid ${token.colorBorderSecondary}`,
              boxShadow: token.boxShadowTertiary
            }}
            bodyStyle={{ padding: '16px' }}
          >
            <Space style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              width: '100%'
            }}>
              <Space size="middle">
                <Avatar 
                  size="large"
                  style={{ 
                    background: `linear-gradient(135deg, ${appt.avatarColor} 0%, ${token.colorPrimaryHover} 100%)`,
                    color: 'white',
                    fontWeight: 'bold'
                  }}
                >
                  {appt.patient.charAt(0)}
                </Avatar>
                <div>
                  <Text strong style={{ 
                    display: 'block', 
                    fontSize: '15px',
                    color: token.colorTextHeading
                  }}>
                    {appt.patient}
                  </Text>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Text type="secondary" style={{ fontSize: '13px' }}>
                      {appt.time} • {appt.duration}
                    </Text>
                    <Badge 
                      color={appt.type === 'Follow-up' ? 'blue' : 'orange'} 
                      text={
                        <Text style={{ 
                          fontSize: '12px',
                          color: appt.type === 'Follow-up' ? token.blue6 : token.orange6,
                          fontWeight: 500
                        }}>
                          {appt.type}
                        </Text>
                      } 
                    />
                  </div>
                </div>
              </Space>
              <Space>
                {appt.urgent && (
                  <Badge 
                    color="red" 
                    text={
                      <Text style={{ 
                        fontSize: '12px',
                        fontWeight: 600,
                        color: token.red6
                      }}>
                        Urgent
                      </Text>
                    } 
                  />
                )}
                <Button 
                  type="primary" 
                  size="small" 
                  shape="round"
                  style={{ transition: 'all 0.3s' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = token.colorPrimaryHover}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = token.colorPrimary}
                >
                  Details
                </Button>
              </Space>
            </Space>
          </Card>
        ))}
      </div>
    </>
  );
};

export default AppointmentCard;